import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AiQuestions } from './aiQuestions';

const routes: Routes = [
  {
    path: '',
    component: AiQuestions
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AiQuestionsRoutingModule {}
